import { Paper } from "eri";

export default function SeeAlso() {
  return (
    <Paper.Group>
      <Paper>
        <h2>See also</h2>
        <p>Here are some other things I&apos;ve made that you might like:</p>
        <ul>
          <li>
            <a href="https://webnotes.link" rel="noopener" target="_blank">
              Webnotes
            </a>{" "}
            is a free and open source web app that lets you create and manage
            notes. It&apos;s simple to use, works offline and because it runs in
            your browser you can use it across all your devices!
          </li>
          <li>
            <a
              href="https://meditation-timer.netlify.app"
              rel="noopener"
              target="_blank"
            >
              Meditate
            </a>{" "}
            is a free and open source web app that allows you to time your
            meditations. It&apos;s simple to use, works offline and aims to be
            the perfect aide for your meditation practice!
          </li>
        </ul>
      </Paper>
    </Paper.Group>
  );
}
